import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Lectures from '../views/Lectures.vue'
import Lecturesinfo from '../views/Lecturesinfo.vue'
import Lecturesinfo2 from '../views/Lecturesinfo2.vue'
import News from '../views/News.vue'
import NewsDetail from '../views/NewsDetail.vue'
import Verification from '../views/Verification.vue'
import About from '../views/About.vue'
import FullDuplex from '../views/FullDuplex.vue'

import Research from '../views/Research.vue'
import Researchinfo from '../views/Researchinfo.vue'
import Standards from '../views/Standards.vue'
import StandardsDetail from '../views/StandardsDetail.vue'
import Medical from '../views/medical.vue'
import i18n from '@/lang/i18n'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title:i18n.t('home')
    }
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: {
      title:i18n.t('news')
    }
  },
  {
    path: '/news/detail',
    name: 'NewsDetail',
    component: NewsDetail,
    meta: { title:i18n.t('news') }
  },
  {
    path: '/verification',
    name: 'Verification',
    component: Verification,
    meta: {
      title:i18n.t('verification')
    }
  },
  // {
  //   path: '/verification1',
  //   name: 'Verification1',
  //   component: Verification1,
  //   meta: {
  //     title:i18n.t('verification')
  //   }
  // },
  {
    path: '/fullDuplex',
    name: 'FullDuplex',
    component: FullDuplex,
    meta: {
      title:i18n.t('full_duplex')
    }
  },
  {
    path: '/research',
    name: 'Research',
    component: Research,
    meta: {
      title:i18n.t('research')
    }
  },
  {
    path: '/research/researchinfo',
    name: 'Researchinfo',
    component: Researchinfo,
    meta: {
      title:i18n.t('research')
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title:i18n.t('about')
    }
  },
  {
    path: '/standards',
    name: 'Standards',
    component: Standards,
    meta: {
      title:i18n.t('standards')
    }
  },
  {
    path: '/standards/detail',
    name: 'StandardsDetail',
    component: StandardsDetail,
    meta: {
      title:i18n.t('standards')
    }
  },
  {
    path: '/lectures',
    name: 'Lectures',
    component: Lectures,
    meta: {
      title:i18n.t('lectures')
    }
  },
  {
    path: '/lectures/lecturesinfo',
    name: 'Lecturesinfo',
    component: Lecturesinfo,
    meta: {
      title:i18n.t('lecturesinfo')
    }
  },
  {
    path: '/lectures/lecturesinfo2',
    name: 'Lecturesinfo2',
    component: Lecturesinfo2,
    meta: {
      title:i18n.t('lecturesinfo')
    }
  },
  {
    path: '/medical',
    name: 'Medical',
    component: Medical,
    meta: {
      title:i18n.t('medical')
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（如后退），则恢复到该位置
    if (savedPosition) {
      return savedPosition;
    } 
    // 否则滚动到顶部
    else {
      return { x: 0, y: 0 };
    }
  }
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router
